// extracted by mini-css-extract-plugin
export default {"rotation":"b6lrVGAafajKih5BA8G4"};